module.exports = __webpack_public_path__ + "02_glasses_black.0bea1eda.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/aoyama/daughter/layer4/02_glasses_black.png
// module id = 5Ajc
// module chunks = 0